// L'onglet « Positions et parcours » de la fiche d'une personnalité (15 octobre 2026).
// Jamais de genre deviné : « cette personnalité », jamais « elle ».
export default {
  titre: 'Ses positions, sujet par sujet',
  echelle: 'L’échelle des positions',
  depuis: 'depuis le {jour}',
  change: 'Change de position le {le} : {avant}, puis {position}',
  frise: 'Ses positions successives sur ce sujet',
  chargement: 'Chargement des positions…',
  vide: 'Aucune prise de position relevée pour l’instant : elles apparaissent quand cette personnalité s’exprime sur un sujet',
}
